import { WalletService } from '../../services/walletService';
import { createPageStore } from '../pageStore';

const walletService = new WalletService();

const fetchData = async (): Promise<Object> => {
  return await walletService.getEarnings();
};

export const useWalletEarningsStore = createPageStore(fetchData);
